import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '',
    title: 'General',
    icon: 'mdi mdi-dots-horizontal',
    class: 'nav-small-cap',
    extralink: true,
    submenu: []
  },
  /* {
    path: '/starter',
    title: 'Starter Page',
    icon: 'mdi mdi-file',
    class: '',
    extralink: false,
    submenu: []
  }, */
  {
    path: '/dashboard/stadistics',
    title: 'Analytics',
    icon: 'fas fa-chart-line',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '',
    title: 'Main Menu',
    icon: 'mdi mdi-dots-horizontal',
    class: 'nav-small-cap',
    extralink: true,
    submenu: []
  },
  {
    path: '/dashboard/config-stand',
    title: 'Configuración Stand',
    icon: 'fas fa-cogs',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/dashboard/categorias',
    title: 'Configuración de Categorías',
    icon: 'fas fa-sliders-h',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/dashboard/expositores',
    title: 'Alta de expositores',
    icon: 'fas fa-users',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/dashboard/visitor',
    title: 'Config Visitante',
    icon: 'fas fa-user-tag',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/dashboard/conferencias',
    title: 'Conferencias',
    icon: 'fas fa-user-tag',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/dashboard/products',
    title: 'Productos',
    icon: 'fas fa-cart-plus',
    class: '',
    extralink: false,
    submenu: []
  },
  /* {
    path: '/users',
    title: 'Users',
    icon: 'mdi mdi-account',
    class: '',
    extralink: false,
    submenu: []
  }, */
  /* {
    path: '/component/poptool',
    title: 'Popover & Tooltip',
    icon: 'mdi mdi-image-filter-vintage',
    class: '',
    extralink: false,
    submenu: []
  }, */
  /* {
    path: '/component/alert',
    title: 'Alerts',
    icon: 'mdi mdi-message-bulleted',
    class: '',
    extralink: false,
    submenu: []
  }, */
  /* {
    path: '/component/carousel',
    title: 'Carousel',
    icon: 'mdi mdi-view-carousel',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/component/dropdown',
    title: 'Dropdown',
    icon: 'mdi mdi-arrange-bring-to-front',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/component/modal',
    title: 'Modal',
    icon: 'mdi mdi-tablet',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/component/pagination',
    title: 'Pagination',
    icon: 'mdi mdi-backburger',
    class: '',
    extralink: false,
    submenu: []
  },
  
  {
    path: '/component/progressbar',
    title: 'Progressbar',
    icon: 'mdi mdi-poll',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/component/rating',
    title: 'Ratings',
    icon: 'mdi mdi-bandcamp',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/component/tabs',
    title: 'Tabs',
    icon: 'mdi mdi-sort-variant',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/component/timepicker',
    title: 'Timepicker',
    icon: 'mdi mdi-calendar-clock',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/component/buttons',
    title: 'Button',
    icon: 'mdi mdi-blur-radial',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/component/card',
    title: 'Card',
    icon: 'mdi mdi-arrange-bring-forward',
    class: '',
    extralink: false,
    submenu: []
  } */
];
